<template>
    <div class="post-navigator flex">
        <button class="active"
        @click="getAllPosts($event.target)"
        >Teraz</button>
        <button
        v-for="(year, index) in years"
        :key="index"
        @click="getPostsByYear(index, $event.target)"
        >{{ year }}</button>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'


export default {
    computed: {
        ...mapState(['years']),
    },
    methods: {
        ...mapActions(['resetState', 'loading', 'loadPosts' ,'loadYearPosts']),
        getPostsByYear(index, elem){

            this.activate(elem);

            const payload = {
                page: 'year',
                year: false,
            }

            this.resetState(payload);
            this.loading(true);
            this.loadYearPosts(this.$store.state.years[index]);
        },
        getAllPosts(elem){
            this.activate(elem);

            const payload = {
                page: null,
                year: true
            }

            this.resetState(payload);
            this.loadPosts();
        },
        activate(elem){

            const buttons = document.querySelectorAll('.post-navigator button');

            [...buttons].forEach(button => {
                button.classList.remove('active');
            })

            elem.classList.add('active');

        }
    }
}
</script>
